import React from "react";
import { Box, Button, Flex, Heading, LinkButton, } from "@catchoftheday/cg-components";
import { OnePassModal } from "../OnePassModal";
import { LinkedModalContent, UnlinkedModalContent } from "./ModalContent";
export const LinkingModal = ({ isOpen, loading, isLinked, email, ctaUrl, onClose, onProceed, }) => {
    return (<OnePassModal isOpen={isOpen} loading={loading} onRequestClose={onClose}>
      <Box fontFamily="onePass" color="onePass.textPrimary" visibility={loading ? "hidden" : "visible"}>
        <Heading.h3 fontWeight="bold" color="onePass.textPrimary" mt={0} mb={6}>
          {isLinked ? "Account already linked" : "Link OnePass"}
        </Heading.h3>
        {isLinked ? (<LinkedModalContent email={email}/>) : (<UnlinkedModalContent email={email}/>)}
        <Flex mt={8} flexDirection={{ xs: "column", md: "row" }}>
          <LinkButton href={ctaUrl} variant="onePassPrimary" flexBasis="50%" sizeVariant="md" fontWeight="semibold" onClick={onProceed}>
            Proceed
          </LinkButton>
          <Button variant="plain" flexBasis="50%" sizeVariant="md" onClick={onClose} color="onePass.primary" fontWeight="semibold" underlineOnHover>
            Cancel
          </Button>
        </Flex>
      </Box>
    </OnePassModal>);
};
